export class BalanceStorage {

  KEYS = {

    PRODUCT_TYPE: "balance_custom_filters_product_types",
    PRODUCT_TYPE_ASSETS: "balance_custom_filters_product_types_asset",
    BIZ_STEP: "balance_custom_filters_biz_steps",
    DISPOSITIONS: "balance_custom_filters_dispositions",
    BIZ_LOCATION: "balance_custom_filters_biz_location"
  }

  clearData() {
    Object.keys(this.KEYS).forEach(x => localStorage.removeItem(x));
  }

  getProductTypes() {
    return localStorage.getItem(this.KEYS.PRODUCT_TYPE);
  }
  getProductTypesByAsset() {
    return localStorage.getItem(this.KEYS.PRODUCT_TYPE_ASSETS);
  }

  getBizSteps() {
    return localStorage.getItem(this.KEYS.BIZ_STEP);
  }

  getDispositions() {
    return localStorage.getItem(this.KEYS.DISPOSITIONS);
  }
  getBizLocation() {
    return localStorage.getItem(this.KEYS.BIZ_LOCATION);
  }

  saveBizLocationData(bizLocations) {
    localStorage.setItem(this.KEYS.BIZ_LOCATION, bizLocations);
  }
  saveProductTypeDate(productTypes) {
    localStorage.setItem(this.KEYS.PRODUCT_TYPE, productTypes);
  }
  saveProductTypeDateByAsset(productTypes) {
    localStorage.setItem(this.KEYS.PRODUCT_TYPE_ASSETS, productTypes);
  }

  saveBizStepData(bizSteps) {
    localStorage.setItem(this.KEYS.BIZ_STEP, bizSteps);
  }

  saveDispositionData(dispositions) {
    localStorage.setItem(this.KEYS.DISPOSITIONS, dispositions);

  }

}



// WEBPACK FOOTER //
// ./src/balance/BalanceStorage.js